module.exports = __webpack_public_path__ + "static/media/img_ktv.10c0a3cc.png";